var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-button',_vm._g(_vm._b({staticClass:"btn rounded-0",on:{"click":_vm.onClick}},'k-button',_vm.$props,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }